import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// Con `href` el botón es un enlace (Urbanismo: solicitar acceso en la app); sin él,
// abre la demo como siempre (Territorio).
export const StickyCTA = ({ onOpenDemo, texto = 'Solicitar demo gratuita', href }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Mostrar después de scrollear 600px
      setVisible(window.scrollY > 600);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const clase =
    'w-full rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors duration-200 py-6 text-base font-medium';

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 md:hidden transition-all duration-300 ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="bg-card/90 backdrop-blur-xl border-t border-border px-4 py-3 safe-area-bottom">
        {href ? (
          <Button asChild className={clase}>
            {href.startsWith('/') ? (
              <Link to={href}>
                {texto}
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            ) : (
              <a href={href}>
                {texto}
                <ArrowRight className="ml-2 w-5 h-5" />
              </a>
            )}
          </Button>
        ) : (
          <Button onClick={onOpenDemo} className={clase}>
            {texto}
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default StickyCTA;
